import { defineStore } from 'pinia';
import { POS_PROVIDERS } from '@/constants/posProviders';

const DEFAULT_FEATURES = {
  includeDrinksInMenu: true,
};

const PROVIDER_FEATURE_OVERRIDES = {
  [POS_PROVIDERS.AGORA]: {
    includeDrinksInMenu: false,
  },
  [POS_PROVIDERS.LAST_APP]: {
    includeDrinksInMenu: false,
  },
};

export const usePosProviderStore = defineStore('posProvider', {
  state: () => ({
    posProviderName: null,
    posProviderFeatures: null,
  }),

  getters: {
    getPosProviderName: (state) => state.posProviderName,
    hasPosProvider: (state) => state.posProviderName !== null && state.posProviderName !== undefined,
    isFeatureEnabled: (state) => (featureKey) => {
      if (state.posProviderFeatures && Object.prototype.hasOwnProperty.call(state.posProviderFeatures, featureKey)) {
        return !!state.posProviderFeatures[featureKey];
      }

      const providerOverride = state.posProviderName
        ? PROVIDER_FEATURE_OVERRIDES[state.posProviderName]?.[featureKey]
        : undefined;

      if (providerOverride !== undefined) {
        return providerOverride;
      }

      if (Object.prototype.hasOwnProperty.call(DEFAULT_FEATURES, featureKey)) {
        return DEFAULT_FEATURES[featureKey];
      }

      return true;
    },
    collectsLocalPayments: (state) => {
      const isExternal =
        state.posProviderName != null && state.posProviderName !== POS_PROVIDERS.WEPOS;
      if (!isExternal) {
        return true;
      }

      return state.posProviderFeatures?.collectPayments === true;
    },
  },

  actions: {
    /**
     * Initialize the POS provider from venue configuration
     * @param {Object} venueConfig - The venue configuration object
     */
    initFromVenueConfig(venueConfig) {
      if (venueConfig && venueConfig.posProvider) {
        this.posProviderName = venueConfig.posProvider;
      }
      if (venueConfig && venueConfig.posProviderFeatures) {
        this.posProviderFeatures = venueConfig.posProviderFeatures;
      }
    },

    /**
     * Set the POS provider name directly
     * @param {string} providerName - The name of the POS provider
     */
    setPosProviderName(providerName) {
      this.posProviderName = providerName;
    },

    /**
     * Clear the POS provider information
     */
    clearPosProvider() {
      this.posProviderName = null;
      this.posProviderFeatures = null;
    },

	isExternalPosProvider() {
		return this.posProviderName != null && this.posProviderName !== POS_PROVIDERS.WEPOS;
	},

	setPosProviderFeatures(featureMap) {
		this.posProviderFeatures = featureMap || null;
	},
  },
});
